import getInstance from 'modules/api/instance';
import getAuthInstance from 'modules/api/instanceAuth';
import { getInstance as getDSInstanceOtp } from 'modules/api/digitalServices/instanceOtp';

const instance = getInstance();
const instanceAuth = getAuthInstance();
const dsInstanceOtp = getDSInstanceOtp();

export const fetchAutoSignin = () => {
  const url = '/auth/auto/login';

  return instance.get(url, { withCredentials: true });
};

export const getLoginAuth = (email) => {
  const url = '/users/exists';

  return instanceAuth
    .post(url, { email, checkHubspotAccount: true })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
};

export const updatePasswordFlag = (email, welcomeJourneyEligible, passwordChangeRequired) => {
  const url = 'users/update-user';

  const payload = {
    email,
    welcomeJourneyEligible,
    passwordChangeRequired,
  };

  return instanceAuth
    .post(url, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
};

export const sendOtpRequest = ({ email, type }) => {
  const url = 'onboard/otp-validator';
  return dsInstanceOtp.post(url, { email, type });
};

export const loginViaOtp = ({ email, code }) => {
  const url = 'onboard/login-via-otp';
  return dsInstanceOtp
    .post(url, { email, code })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
};
